var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7587 1.27945C19.4253 0.888413 18.8587 0.790654 18.4253 1.08393L16.492 2.38738C15.592 1.44238 14.3253 0.920999 12.9587 0.920999C10.2587 0.920999 8.02532 3.07169 8.02532 5.74377C8.02532 6.1348 8.05865 6.49325 8.15865 6.8517C5.82532 6.36291 4.42532 4.70101 3.89198 1.70307C3.82532 1.31203 3.52532 1.01876 3.12532 0.920999C2.75865 0.82324 2.35865 0.986171 2.12532 1.27945C2.05865 1.34462 -3.44135 8.83946 4.52532 15.1938C3.75865 16.7905 1.45865 18.1591 0.558651 18.6153C0.125318 18.8109 -0.0746825 19.2671 0.0253176 19.7233C0.125318 20.1795 0.525318 20.4728 0.991984 20.4728H2.72532C12.8587 20.4728 17.4587 15.5522 17.5587 4.53808L19.6587 2.5829C20.0587 2.25704 20.092 1.67048 19.7587 1.27945Z",
    fill: "#505F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b3c5994a4ddfab2c18b595324b73e66d.svg";
export { ForwardRef as ReactComponent };